import { module } from 'modujs';
import Background from '../utils/background';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.background = new Background(this.el, {
            theme: this.getData('theme'),
            // debug: false,
        })
    }

    // Probably called by CtaContact
    expand() {
        for(let gradient of this.background.gradients) { gradient.expand() }
    }

    // Probably called by CtaContact
    shrink() {
        for(let gradient of this.background.gradients) { gradient.shrink() }
    }

    destroy() {
        this.background.destroy()
    }
}
